import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';

export const GetDefaultNotification: any = createAsyncThunk<any>(
	'GetDefaultNotification',
	async () => {
		const response = await httpService.get(
			`system-portal/get-tenant-defaults`
		);
		return response.data.data;
	}
);
//working
export const addUser: any = createAsyncThunk<any>(
	'addUser',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.post('tenant-portal/user', data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
//not done
export const getUserDetails: any = createAsyncThunk<any>(
	'getUserDetails',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.get('tenant-portal/user', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getSettingUserList: any = createAsyncThunk<any>(
	'getSettingUserList',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.get('tenant-portal/users', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
//not done
export const editUser: any = createAsyncThunk<any>(
	'editUser',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put('/tenant-portal/user', data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const tenantBranches: any = createAsyncThunk<any>(
	'tenantBranches',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.get('/tenant-portal/branches', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getSupervisorsList: any = createAsyncThunk<any>(
	'getSupervisorsList',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.get(
				'/tenant-portal/supervisors',
				{ params: data }
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const updateUsersStatus: any = createAsyncThunk<any>(
	'updateUsersStatus',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`/tenant-portal/users`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const deleteUser: any = createAsyncThunk<any>(
	'deleteUser',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.delete(`/tenant-portal/user`, {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const getSalesPersonList: any = createAsyncThunk<any>(
	'getSalesPersonList',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.get(
				'/tenant-portal/salesperson',
				{ params: data }
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getUserDetailsFromIds: any = createAsyncThunk<any>(
	'getUserDetailsFromIds',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.post('tenant-portal/usersDetails', data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
